import { render, staticRenderFns } from "./ModalPasswordChanged.vue?vue&type=template&id=2a1edeb7&"
import script from "./ModalPasswordChanged.vue?vue&type=script&lang=js&"
export * from "./ModalPasswordChanged.vue?vue&type=script&lang=js&"
import style0 from "./ModalPasswordChanged.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports